module.exports = __webpack_public_path__ + "img/erp-logos_0033_fishbowl.31978b18.jpg";